import {Link} from "react-router-dom";
import { useEffect, useState } from "react";
import HeaderNavContent from "../header/HeaderNavContent";

const Header = ({ secondLogo }) => {
  const [navbar, setNavbar] = useState(false);
  const changeBackground = () => {
    if (window.scrollY >= 10) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
    return () => window.removeEventListener("scroll", changeBackground);
  }, []);

  return (
    // <!-- Main Header-->
    <header
      className={`main-header header-shaddow -type-11 ${
        navbar ? "fixed-header animated slideInDown" : ""
      }`}
    >
        {/* <!-- Main box --> */}
      {secondLogo && (
        <div className="main-box">
          {/* <!--Nav Outer --> */}
          <div className="nav-outer">
            <div className="logo-box">
              <div className="logo">
                <Link to="/incluvia">
                  <img
                          width={200}
                          src="/images/hotline-TH%201.png"
                          alt="Logo Hotline Talents Handicap"
                  />
                </Link>

                <Link to="/incluvia">
                  <img
                          width={250}
                          src="/images/incluvia.png"
                          alt="Logo Hotline Talents Handicap"
                  />
                </Link>

              </div>
            </div>
            {/* End .logo-box */}
            <HeaderNavContent page={"incluvia"} />
            {/*<HeaderNavContent />
             <!-- Main Menu End--> */}
          </div>
          {/* End .nav-outer */}
        </div>
      )}
    </header>
  );
};

export default Header;
